import { observable } from "aurelia-framework";
import { applicationLogger } from "../../../../logging/logger";
import * as moment from "moment";
import { AdminApi } from "../../../../services/admin-api";
import { Kiosk } from "../../../../models/kiosk";
import { DataRequestViewModel } from "../../../../models/data-request-view-model";
import { KioskMeasurementViewModel } from "../../../../models/kiosk-measurement-view-model";
import { I18N } from "aurelia-i18n"

export class BaseDeviceChart {
	active: boolean = false;
	hasData: boolean = false;

	chart: any;

	kiosk: Kiosk;
	startDate: string;
	endDate: string;

	min: number;
	max: number;
	step: number;
	@observable days: any;

	chartOptions: any;
	chartData: any;
	@observable isAttached: boolean = false;

	startTimePicker: any;
	showStartTimePicker: boolean = false;

	endTimePicker: any;
	showEndTimePicker: boolean = false;

	rangeSelection: any;

	protected api: AdminApi;

	constructor(api: AdminApi) {
		this.api = api;
		this.configureChart();

		this.min = -365;
		this.max = -1;
		this.step = 1;

		this.rangeSelection = [
			{ name: "Day", value: -1 },
			{ name: "Week", value: -7 },
			{ name: "Month", value: -30 },
			{ name: "Year", value: -365 }
		];

		this.days = this.rangeSelection[0];
	}

	daysChanged() {
		if (this.isAttached) {
			this.getGraphData(this.days.value);
		}
	}

	isAttachedChanged() {
		if (this.isAttached) {
			this.getGraphData(this.days.value);
		}
	}

	public bindKiosk(kiosk: Kiosk) {

		this.isAttached = false;
		this.kiosk = kiosk;

		this.hasData = false;

		this.configureChartOptions();
		this.configureChartAxes();

		this.days = this.rangeSelection[0];
		this.isAttached = true;

	}

	private configureChart() {
		this.configureChartOptions();
		this.configureChartAxes();
	}

	protected configureDatasets() {
		// no-op
	}

	protected configureChartAxes() {
		// no-op
	}

	protected configureChartOptions() {
		// no-op
	}





	protected processData(data: any) {
		// no-op
	}

	async onChange(days: number) {
		this.days = days;
		await this.getGraphData(this.days);
	}


	public async getData() {

		const viewModel = new DataRequestViewModel();
		viewModel.kioskId = this.kiosk.id;
		viewModel.startDate = moment(this.startDate).toISOString(true);
		viewModel.endDate = moment(this.endDate).toISOString(true); 
		await this.getDataInternal(viewModel);
	}

	protected async getDataInternal(viewModel:DataRequestViewModel) {
		//// ReSharper restore InconsistentNaming
		//this.active = true;
		//let response = await this.api.getKioskMeasurementData(viewModel);

		//if (response.success && response.data) {
		//	this.processData(response.data);
		//} else {
		//	applicationLogger.error(response.message);
		//}

		//this.active = false;
	}

	async getGraphData(days: number = -1) {

		const end = moment().hours(23).minutes(59).seconds(59);
		this.endDate = end.format("YYYY-MM-DD HH:mm:ss");
		const start = moment().hours(0).minutes(0).seconds(0).add(moment.duration(this.days.value, "day"));
		this.startDate = start.format("YYYY-MM-DD HH:mm:ss");
		const viewModel = new DataRequestViewModel();
		viewModel.kioskId = this.kiosk.id;
		viewModel.startDate = moment(this.startDate).toISOString(true);
		viewModel.endDate = moment(this.endDate).toISOString(true); 
	

		await this.getDataInternal(viewModel);

	}

	handleResize(detail) {
		// this.showTip = detail.width < 450;
	}

	showTimePicker(control: string) {
		applicationLogger.info("'showTimePicker' called.");

		switch (control) {
			case "start":
				{
					this.showStartTimePicker = true;
					this.startTimePicker.open();
					break;
				}
			case "end":
				{
					this.showEndTimePicker = true;
					this.endTimePicker.open();
					break;
				}
		}
	}

	hideTimePicker(control: string) {
		applicationLogger.info("'hideDatePicker' called.");
		switch (control) {
			case "start":
				{
					this.showStartTimePicker = false;
				}
			case "end":
				{
					this.showEndTimePicker = false;
				}
		}
	}
}
